module.exports = __webpack_public_path__ + "img/reservation-active.1538a473.png";